// assets
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import LoginOutlined from '@ant-design/icons/LoginOutlined';
import PhoneOutlined from '@ant-design/icons/PhoneOutlined';
import HistoryOutlined from '@ant-design/icons/HistoryOutlined';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import RocketOutlined from '@ant-design/icons/RocketOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import { ContactSupportOutlined, WavesOutlined } from '@mui/icons-material';
// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  DollarOutlined,
  LoginOutlined,
  PhoneOutlined,
  RocketOutlined,
  HistoryOutlined,
  QuestionCircleOutlined,
  ContactSupportOutlined,
  CalendarOutlined,
  WavesOutlined
};

// ==============================|| MENU ITEMS - PAGES ||============================== //

const str: NavItemType = {
  id: 'str-pages',
  title: 'STR',
  type: 'group',
  divider: true,
  children: [
    {
      id: 'str-calendar',
      title: 'Bookings',
      type: 'item',
      url: '/str/calendar',
      icon: icons.CalendarOutlined,
      target: false,
      permission: 'canViewStr'
    },
    {
      id: 'str-rental-properties',
      title: 'Rental Properties',
      type: 'item',
      url: '/rental-properties',
      icon: icons.WavesOutlined,
      target: false,
      permission: 'canViewStr'
    }
  ]
};

export default str;
